import { createStyles, InputBase, withStyles } from '@material-ui/core';
import { alpha } from '@material-ui/core/styles/colorManipulator';
import { isCapitalUI } from 'react-common/theme';
import { capitalTokens } from 'react-common/capitalTheme';
export const BootstrapInput = withStyles((theme) => createStyles(isCapitalUI ? {
    input: {
        position: 'relative',
        borderRadius: `${capitalTokens.radius.field}px !important`,
        backgroundColor: 'transparent',
        border: 'none',
        padding: '18px 40px 4px 16px !important',
        height: '20px !important',
        lineHeight: '20px',
        cursor: 'pointer',
        '&:focus': { borderRadius: capitalTokens.radius.field, backgroundColor: 'transparent' },
        '&:disabled': { color: theme.palette.text.disabled, cursor: 'default' },
        '& option': { color: capitalTokens.text, backgroundColor: capitalTokens.surface },
        '& option:disabled': { color: theme.palette.text.disabled },
    },
    root: {
        minWidth: 0,
        minHeight: capitalTokens.fieldHeight,
        borderRadius: capitalTokens.radius.field,
        border: `1px solid ${capitalTokens.border}`,
        backgroundColor: capitalTokens.surface,
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:hover:not(.Mui-disabled), &.Mui-focused': { borderColor: capitalTokens.primary },
        '&.Mui-focused': { boxShadow: `0 0 0 3px ${alpha(capitalTokens.primary, .18)}` },
        '&.Mui-error, &.Mui-error:hover': { borderColor: capitalTokens.error },
        '&.Mui-disabled': { backgroundColor: capitalTokens.canvas },
    },
} : {
    input: {
        borderRadius: '4px !important',
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        border: 'none',
        padding: '27px 12px 10px',
        paddingRight: '48px !important',
        cursor: 'pointer',
        '&.MuiInputBase-inputAdornedEnd': {
            backgroundColor: theme.palette.background.paper,
            borderRight: 'none',
            borderTopRightRadius: '0 !important',
            borderBottomRightRadius: '0 !important',
        },
        '&.MuiInputBase-inputAdornedEnd ~ *': {
            backgroundColor: theme.palette.background.paper,
            borderLeft: 'none',
            borderTopLeftRadius: '0 !important',
            borderBottomLeftRadius: '0 !important',
            borderTopRightRadius: '4px !important',
            borderBottomRightRadius: '4px !important',
            height: '100%',
        },
        '&:disabled, &:disabled ~ *': {
            backgroundColor: `${theme.palette.grey["300"]} !important`,
        },
        '#flight-search-filters &:disabled, #flight-search-filters &:disabled ~ *': {
            backgroundColor: `${theme.palette.common.white} !important`,
            color: theme.palette.common.black,
        }
    },
    root: {
        borderRadius: '4px !important',
        border: '1px solid #ced4da',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus, &:hover': {
            backgroundColor: theme.palette.background.paper,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: theme.palette.primary.main,
            transition: 0,
        },
        '&.Mui-error': {
            borderColor: theme.palette.error.main,
        },
    }
}))(InputBase);
